import BottomHeaderContainer from './BottomHeaderContainer';

export default BottomHeaderContainer;